import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import MainLayout from "./components/app/layout/MainLayout";
import HomePage from "./pages/HomePage";
import ContactPage from "./pages/ContactPage";
import CareersPage from "./pages/CareersPage";
import CompanyPage from "./pages/CompanyPage";
import AboutusPage from "./pages/AboutusPage";
import PositionPage from "./pages/PositionPage";
import SkillDevelopmentPage from "./pages/SkillDevelopmentPage";
import LearningPage from "./pages/LearningPage";
import ConsultancyPage from "./pages/ConsultancyPage";
import TrainingPage from "./pages/TrainingPage";
import ScrollToTop from "./components/ScrollToTop";
import TourismPage from "./pages/TourismPage";

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<MainLayout />}>
          <Route index element={<HomePage />} />
          <Route path="company" element={<CompanyPage />} />
          <Route path="careers" element={<CareersPage />} />
          {/* <Route path="careers/:slug" element={<PositionPage />} /> */}
          <Route path="contact" element={<ContactPage />} />
          <Route path="aboutus" element={<AboutusPage />} />
          <Route path="skill-development" element={<SkillDevelopmentPage />} />
          <Route path="learning" element={<LearningPage />} />
          <Route path="consultancy" element={<ConsultancyPage />} />
          <Route path="training" element={<TrainingPage />} />
          <Route path="tourism" element={<TourismPage />} />
        </Route>
        <Route path="*" element={<div>Not Found</div>} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
